import React from "react";

const About = () => {
  return (
    <>
      <h1> About This App</h1>
      <p> App to search Github users </p>
      <p> Version: 1.0.1</p>
    </>
  );
};

export default About;
